import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';

import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';

import Avatar from '@material-ui/core/Avatar';



export default class CursoInteresse extends React.Component {

    componentDidMount() {
        document.querySelector(".scrollView").scrollIntoView({ behaviour: "smooth" });
        this.props.carregarFinanciamentosdisponiveis();
    }

    render() {
        var periodo = (

            <FormControl className='item-form' >
                <InputLabel htmlFor="per-codigo">Período</InputLabel>
                <Select
                    disabled={this.props.curCodigo == 0}
                    style={{ width: "300px" }}
                    value={this.props.perPeriodo > 0 ? this.props.perPeriodo : ""}
                    onChange={this.props.onChangePeriodo}
                    inputProps={{
                        id: 'per-codigo'

                    }}
                >
                    <MenuItem value={0}>--SELECIONE--</MenuItem>
                    {this.props.listPeriodo.map((c, indice) => {
                        return (
                            <MenuItem key={indice} value={c.per_periodo}>{c.per_descricao}</MenuItem>
                        );
                    })}
                </Select>
            </FormControl>

        );

        var polo = (
            <FormControl className='item-form' >
                <InputLabel htmlFor="pol-codigo">Polo</InputLabel>
                <Select
                    disabled={this.props.curCodigo == 0 || this.props.perPeriodo == 0}
                    style={{ width: "300px" }}
                    value={this.props.polCodigo > 0 ? this.props.polCodigo : ""}
                    onChange={this.props.onChangePolo}
                    inputProps={{
                        id: 'pol-codigo'

                    }}
                >
                    <MenuItem value={0}>--SELECIONE--</MenuItem>
                    {this.props.listPolo.map((c, indice) => {
                        return (
                            <MenuItem key={indice} value={c.pol_codigo}>{c.pol_descricao}</MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        );
        return (
            <div >
                {this.props.carregando ? <LinearProgress color="primary" /> : null}

                <div>
                    <FormControl className='item-form' >
                        <InputLabel htmlFor="cur-codigo">Curso de Interesse</InputLabel>
                        <Select
                            style={{ width: "300px" }}
                            value={this.props.curCodigo > 0 ? this.props.curCodigo : ""}
                            onChange={this.props.onChangeCursoInteresse}
                            inputProps={{
                                id: 'cur-codigo'
                            }}
                        >
                            <MenuItem value={0}>--SELECIONE--</MenuItem>
                            {this.props.listCursos.map((c, indice) => {
                                return (
                                    <MenuItem key={indice} value={c.cur_codigo}>{c.cur_nomcur}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>


                    {this.props.curCodigo === 0 ? (
                        <Tooltip id="tooltip-top" title="Selecione um Curso" placement="bottom">
                            {periodo}
                        </Tooltip>
                    ) : periodo}

                    {this.props.curCodigo === 0 || this.props.perPeriodo === 0 ? (
                        <Tooltip id="tooltip-top" title="Selecione um Periodo" placement="bottom">
                            {polo}
                        </Tooltip>
                    ) : polo}
                </div>

                <div>
                    <FormControl className='item-form' >
                        <TextField
                        disabled={!this.props.curCodigo || !this.props.polCodigo}
                            type="number"
                            InputProps={{
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                            style={{ width: "300px" }}
                            id="percDesejado"
                            label="Percentual de financiamento desejado"
                            value={this.props.solPercentual > 0 ? this.props.solPercentual : ""}
                            onChange={this.props.onChangePercentDesejado}
                            margin="normal"
                            helperText={"Limite para o curso de interesse: " + this.props.maximoPercent + " %"}

                        />
                    </FormControl>

                    {this.props.curURL ? (
                        <FormControl className='item-form' >

                            <Chip
                                avatar={<Avatar>R$</Avatar>}
                                label={<Button target="_blank" href={"http://www.unoeste.br/Graduacao/" + this.props.curURL + "/ValorMensalidade"}> Consulte valor do curso  </Button>}

                            >

                            </Chip>


                        </FormControl>

                    ) : null}

                </div>
                <div>

                    <FormControl className='item-form' style={{display:"block"}} >
                    <InputLabel   >Motivo da Solicitação</InputLabel>
                        <Input
                            rows={10}
                            type="text"
                            multiline={true}
                            style={{
                               
                                width: "100%",
                                border: "1px solid #aaa",
                              
                            }}
                            id="solMotivo"
                         
                            value={this.props.solMotivo}
                            onChange={this.props.onChangeMotivo}
                           
                            
                            

                        />
                    </FormControl>
                </div>

            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/curso-interesse.js